<script lang="ts">
  import {
    openOverlay,
    setOverlayCloseDisabled,
  } from "@kontextwerk/web-sdk/core/overlay/globalStores"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import ActionBox from "@kontextwerk/web-sdk/ui/layout/ActionBox.svelte"
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import type { DemoDataResetResponse } from "../../../../../../../../../../api/kehrblatt/demo-data"
  import DemoDataResetOverlay from "./_modules/demo-data-reset-overlay"

  const { organizationId, disabled = false } = $props<{
    organizationId: string
    disabled?: boolean
  }>()

  let result = $state<DemoDataResetResponse | null>(null)

  const openResetOverlay = () => {
    let overlayId = ""
    overlayId = openOverlay({
      title: "Testzugang zurücksetzen",
      content: DemoDataResetOverlay,
      bodyPadding: "none",
      defaultFullscreen: true,
      properties: {
        organizationId,
        setCloseDisabled: (disabled: boolean) => {
          setOverlayCloseDisabled(overlayId, disabled)
        },
        onResetDone: (value: DemoDataResetResponse) => {
          result = value
        },
      },
    })
  }

  const countEntries = $derived(
    Object.entries(result?.counts ?? {}).filter(([, value]) => value > 0),
  )
</script>

<SectionTitle
  title="Testdaten"
  small={true}
  brightBackground={true}
  helpModalTextId="organizationTestData"
>
  {#snippet buttonSnippet()}
    <CTA
      type="primaryButton"
      content="Testzugang zurücksetzen"
      onClick={openResetOverlay}
      {disabled}
      small={true}
    />
  {/snippet}
</SectionTitle>

<ActionBox label="Testzugang zurücksetzen">
  <div class="content">
    <p>
      Setzt Aufträge, Termine, Kontaktaufträge, Mitteilungen, Liegenschaften und Ansprechpartner
      dieses Testzugangs auf einen frischen Beispielstand zurück.
    </p>
    <p>
      Chef und Geselle erhalten eigene Zugänge und Ansprechpartner-Kontaktdaten. Die
      Beispiel-Liegenschaften werden vollständig zwischen beiden Profilen aufgeteilt.
    </p>
    <p>Testzugänge werden sonntags um 02:00 Uhr (Europe/Berlin) automatisch zurückgesetzt.</p>
    {#if result}
      <div class="summary">
        <strong>Letzter Reset:</strong>
        <span>{result.base_date} · Kalender: {result.calendar_sync_status}</span>
      </div>
      {#if countEntries.length}
        <div class="counts">
          {#each countEntries as [label, value]}
            <span>{label}: {value}</span>
          {/each}
        </div>
      {/if}
      {#if result.warnings.length}
        <ul class="warnings">
          {#each result.warnings as warning}
            <li>{warning}</li>
          {/each}
        </ul>
      {/if}
    {/if}
  </div>
</ActionBox>

<style lang="less">
  .content {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    p,
    strong {
      margin: 0;
      color: var(--text-invers-100);
    }
  }

  .summary {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .counts {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;

    span {
      border: 1px solid var(--text-invers-100);
      padding: 0.15rem 0.45rem;
      font-weight: 700;
      color: var(--text-invers-100);
    }
  }

  .warnings {
    margin: 0;
    padding-left: 1.1rem;
  }
</style>
